<template>
  <div id="table">
    <div class="divTable greyGridTable">
      <div class="divTableHeading">
        <div class="divTableRow">
          <div class="divTableHead">S No</div>
          <div class="divTableHead">Body</div>
          <div class="divTableHead">Tags</div>
          <div class="divTableHead">Option 1</div>
          <div class="divTableHead">Option 2</div>
          <div class="divTableHead">Option 3</div>
          <div class="divTableHead">Option 4</div>
          <div class="divTableHead">Option 5</div>
          <div class="divTableHead">Explanation</div>
          <div class="divTableHead">Actions</div>
        </div>
      </div>
      <div class="divTableBody">
        <div v-for="(row, i) in tableData" :key="i + ''" class="divTableRow">
          <div class="divTableCell" style="width:25px">{{ i + 1 }}</div>
          <div
            class="divTableCell"
            style="width:238px"
            v-html="renderMarkdownToHTML(row.content)"
          />
          <div class="divTableCell" style="max-width:43px">
            {{
              row.qtags
                .map(tags => {
                  return tags.name
                })
                .join(", ")
            }}
          </div>
          <div
            v-for="i in optionsToDisplay(row.list.options)"
            :key="`isThisCellAnAnswer-${i}`"
            :class="isThisCellAnAnswer(row, row.list.options[i - 1])"
            style="width:148px"
            v-html="renderMarkdownToHTML(row.list.options[i - 1].item)"
          />
          <div
            v-for="i in padOptionsWithPadding(row.list.options)"
            :key="i + row.id + ''"
            class="divTableCell "
          >
            -
          </div>
          <div
            class="divTableCell "
            :class="
              moreOptionsLeft(row.list.options)
                ? 'more-options-hidden-cell'
                : ''
            "
          />
          <div
            class="divTableCell "
            style="width:132px"
            v-html="renderMarkdownToHTML(row.explain)"
          />
          <div class="divTableCell">
            <span class="editbutton link" @click="EditQuestion(row)">Edit</span>
            <span class="deletebutton  link" @click="DeleteQuestion(row)"
              >x</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex"

export default {
  props: ["tableData"],
  data() {
    return {
      markdownRenderer: undefined,
    }
  },
  methods: {
    ...mapActions("module", ["SET_CURRENT_TAG_LIST", "SET_ORIGINAL_TAG_LIST"]),
    renderMarkdownToHTML(markdown) {
      return markdown
    },
    moreOptionsLeft(options) {
      if (options === undefined) {
        return false
      }
      if (options.length >= 5) {
        return true
      }
      return false
    },
    isIdPartOfAnswerArray(id, answerArray) {
      if (answerArray === undefined) {
        return false
      }
      for (let i = 0; i < answerArray.length; i++) {
        if (answerArray[i].key === id) {
          return true
        }
      }
      return false
    },
    isThisCellAnAnswer(row, item) {
      const classes = ["divTableCell"]

      if (this.isIdPartOfAnswerArray(item.id, row.answers)) {
        classes.push("answer-cell")
      }
      return classes.join(" ")
    },
    optionsToDisplay(options) {
      if (options === undefined) {
        return false
      }
      if (options.length >= 5) {
        options = options.slice(0, 4)
        return options.length
      }
      return options.length
    },
    padOptionsWithPadding(options) {
      if (options === undefined) {
        return false
      }
      if (options.length >= 5) {
        return 0
      }
      return 4 - options.length
    },

    findElementInAnArray(arr, elem) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] === elem) {
          return true
        }
      }
      return false
    },
    EditQuestion(row) {
      const tags = row.qtags.map(a => ({ name: a.name, id: a.id }))
      this.SET_CURRENT_TAG_LIST(tags)
      this.SET_ORIGINAL_TAG_LIST(JSON.parse(JSON.stringify(tags)))
      this.$emit("editClicked", row)
    },
    DeleteQuestion(row) {
      this.$emit("deleteClicked", row)
    },
  },

  mounted() {
    this.markdownRenderer = window.markdownit()
  },
}
</script>

<style>
.more-options-hidden-cell {
  background-color: #3fdde4;
}
.answer-cell {
  background-color: #81ff81;
}
.editbutton {
  color: blue;
  cursor: pointer;
}

.deletebutton {
  padding-left: 10px;
  color: red;
  cursor: pointer;
}
.editbutton:hover,
.deletebutton:hover {
  color: black;
}

.editing-question-answer {
  color: white;
  background-color: #41b883;
}
p {
  margin: 0;
}

div.greyGridTable {
  width: 100%;
  border: 1px solid #ffffff;
  border-collapse: collapse;
  text-align: center;
}
.divTable.greyGridTable .divTableCell,
.divTable.greyGridTable .divTableHead {
  padding: 0px 2px;
}
.divTable.greyGridTable .divTableBody .divTableCell {
  border: 1px solid #b6b6b6;
  font-size: 13px;
}
.divTable.greyGridTable .divTableRow:nth-child(even) {
  background: rgba(0, 0, 0, 0.2);
}
.divTable.greyGridTable .divTableCell:nth-child(even) {
}
.divTable.greyGridTable .divTableHeading {
  border-bottom: 4px solid #333333;
  background: yellow;
}
.divTable.greyGridTable .divTableHeading .divTableHead {
  border-left: 2px solid #333333;
  color: black;
  font-size: 15px;
  font-weight: bold;
  text-align: center;
}
.content {
  color: black;
}
.divTable.greyGridTable .divTableHeading .divTableHead:first-child {
  border-left: none;
}

.greyGridTable .tableFootStyle {
  font-size: 14px;
}
/* DivTable.com */
.divTable {
  display: table;
}
.divTableRow {
  display: table-row;
  height: 1px;

  padding: 11px;
  border-collapse: collapse;
}
.divTableHeading {
  display: table-header-group;
}
.divTableHead {
  display: table-cell;
  padding: 2px;
}
.divTableCell {
  display: table-cell;
  overflow: hidden;
  max-width: 140px;
  max-height: 200px;
  padding: 2px;
  border: 1px solid #b6b6b6;
  font-size: 13px;
  white-space: nowrap;
  word-wrap: break-word;
}
.divTableRow:hover > .divTableCell {
  overflow: visible;
  white-space: normal;
}

.divTableHeading {
  display: table-header-group;
}
.divTableFoot {
  display: table-footer-group;
}
.divTableBody {
  display: table-row-group;
}

.divTableCell > pre {
  display: none;
  visibility: hidden;
  overflow: hidden;
  white-space: pre-wrap; /* css-3 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  white-space: nowrap;
  word-wrap: break-word;
}
.divTableCell:hover > pre {
  display: inline;
  visibility: visible;
  white-space: pre-line;
  white-space: pre-wrap;
  word-wrap: initial;
}
</style>
